import type { EmailIntegration } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

interface AuthUriResponse {
  auth_uri: string
}

interface GetAuthUriParams {
  provider: string
  returnTo?: string
  source?: string
  emailIntegrationId?: string
}

export function getAuthUri(context: ApiContext, params: GetAuthUriParams) {
  const searchParams = new URLSearchParams({
    provider: params.provider,
  })

  if (params.returnTo) {
    searchParams.append("returnTo", params.returnTo)
  }

  if (params.source) {
    searchParams.append("source", params.source)
  }

  if (params.emailIntegrationId) {
    searchParams.append("email_integration_id", params.emailIntegrationId)
  }

  return apiContextFetch<AuthUriResponse>(context, `email_integrations/get_auth_uri?${searchParams.toString()}`)
}

export function fetchEmailIntegrations(context: ApiContext) {
  return apiContextFetch<EmailIntegration[]>(context, "email_integrations")
}

export function fetchBookEmailIntegrations(context: ApiContext, bookId: string) {
  return apiContextFetch<EmailIntegration[]>(context, `books/${bookId}/email_integrations`)
}

export function fetchEmailIntegration(context: ApiContext, id: string) {
  return apiContextFetch<EmailIntegration>(context, `email_integrations/${id}`)
}

export function updateEmailIntegration(context: ApiContext, id: string, data: Partial<EmailIntegration>) {
  return apiContextFetch<EmailIntegration>(context, `email_integrations/${id}`, {
    method: "PUT",
    body: JSON.stringify({ email_integration: data }),
  })
}

export function deleteEmailIntegration(context: ApiContext, id: string) {
  return apiContextFetch(context, `email_integrations/${id}`, {
    method: "DELETE",
  })
}
